import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PlaceloaderComponent } from './placeloader.component';

@NgModule({
  imports: [CommonModule],
  declarations: [PlaceloaderComponent],
  exports: [PlaceloaderComponent],
})
export class PlaceloaderModule {}
export { PlaceloaderComponent } from './placeloader.component';
